<!-- Divider -->
<div
    class="cb-horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
